import { Component, Input } from '@angular/core';

@Component({
  selector: 'tart-meta-data-bar',
  templateUrl: './meta-data-bar.component.html',
  styleUrls: ['./meta-data-bar.component.scss'],
})
export class MetaDataBarComponent {

  @Input() options: {
    name: string;
    count: number;
  }[];

}
